import { createAction } from 'redux-actions';

import { callApi, getEndpoint } from 'src/utils/api';
import { getAPITransactionType } from 'src/utils/transactions-util';

const USER_PERSONAL_INFORMATION = 'USER_PERSONAL_INFORMATION';
const GET_USER_MESSAGE = 'GET_USER_MESSAGE';
const ADDRESS_NORMALIZATION = 'ADDRESS_NORMALIZATION';
const VALID = 'VALID';
const CORRECTED = 'CORRECTED';

export default function personalInformation(
  state = {
    isLoading: false,
    normalizing: false,
    isLoaded: false,
    normalized: false,
    hasFailed: false,
    unableToNormalize: false,
    normalizedAddress: null,
    data: {},
    messagesNumber: 0,
  },
  { payload, type }
) {
  switch (type) {
    case `${USER_PERSONAL_INFORMATION}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${USER_PERSONAL_INFORMATION}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        data: payload.body,
      };

    case `${USER_PERSONAL_INFORMATION}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: true,
      };
    case `${ADDRESS_NORMALIZATION}_PENDING`:
      return {
        ...state,
        normalizing: true,
        normalized: false,
      };
    case `${ADDRESS_NORMALIZATION}_FULFILLED`: {
      const VALIDATION_STATUS = payload.body[0].validationStatus;
      const NORMAL =
        VALIDATION_STATUS === VALID || VALIDATION_STATUS === CORRECTED;
      return {
        ...state,
        normalizing: false,
        normalized: NORMAL,
        unableToNormalize: !NORMAL,
        normalizedAddress:
          VALIDATION_STATUS === CORRECTED
            ? payload.body[0].correctedAddress
            : payload.body[0].originalAddress,
      };
    }
    case `${ADDRESS_NORMALIZATION}_REJECTED`:
      return {
        ...state,
        normalizing: false,
        unableToNormalize: true,
      };
    case `${GET_USER_MESSAGE}_FULFILLED`: {
      const num = payload.body.filter((message) => !message.viewed).length;
      return {
        ...state,
        messagesNumber: num,
      };
    }
    default:
      return state;
  }
}

export const getPersonalInformation = () => {
  return (dispatch) => {
    const action = createAction(USER_PERSONAL_INFORMATION)(
      callApi(
        `${getEndpoint(
          'personalInformation'
        )}?transactionType=${getAPITransactionType()}`
      )
    );
    return dispatch(action);
  };
};

export const getUserMessages = () => {
  return (dispatch) => {
    const action = createAction(GET_USER_MESSAGE)(
      callApi(`${getEndpoint('getMessages')}`)
    );
    return dispatch(action);
  };
};

export const normalizeAddress = (street1, state, zip, city) => {
  const requestBody = [
    {
      street1,
      state,
      zip,
      city,
      usaddress: true,
    },
  ];
  return (dispatch) => {
    const action = createAction(ADDRESS_NORMALIZATION)(
      callApi(getEndpoint('addressValidation'), { method: 'POST' }, requestBody)
    );
    dispatch(action);
  };
};
